import Webinars from './WebinarsContainer.vue';

export { Webinars };



// WEBPACK FOOTER //
// ./src/modules/home/webinars/index.js